import { render, staticRenderFns } from "./InputHistory.vue?vue&type=template&id=5cc346db&"
import script from "./InputHistory.vue?vue&type=script&lang=js&"
export * from "./InputHistory.vue?vue&type=script&lang=js&"
import style0 from "./InputHistory.vue?vue&type=style&index=0&id=5cc346db&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports